export default __webpack_public_path__ + "images/c1a5c2920949d6078be2df8fecad8c3f-austin_desktop.webp";